export const SUPERADMIN = 1
export const ADMIN = 2
export const BILLER = 4